export default __webpack_public_path__ + "static/media/amazon-eks.f4bbae3a73a1406f843a7c7a148910a2.svg";